import { loginActionTypes } from '../login/login.constants';
import { PersonalInfoActionTypes } from '../details/personalInfo/personalInfoActionType';
import { rakutenServicesActionTypes } from '../details/privacyCenter/rakutenServices/legacy/rakutenServices.constants';
import { UpdateEmailActionType } from '../details/accountSecurity/updateEmail/updateEmailActionType';
import { UpdateUsernameActionType } from '../details/accountSecurity/updateUsername/updateUsernameActionType';
import { appActionTypes } from './app.constants';
import { DidomiActionType } from '../details/didomi/didomiActionType';

export function appReducer(state = { isReady: false }, action) {
    switch (action.type) {
        case 'SERVER_FIVE_HUNDRED':
            return { ...state, fiveHundred: true };
        case appActionTypes.SET_APP_CONFIG:
            return {
                ...state,
                appConfig: action.appConfig,
            };
        case appActionTypes.SET_CLIENT_CONFIG:
            const userSetLocale = localStorage.getItem('userSetLocale');
            if (!userSetLocale) {
                return {
                    ...state,
                    clientConfig: action.clientConfig,
                    locale: action.clientConfig.lang || 'en',
                    presentationConfig: action.presentationConfig,
                };
            }

            return {
                ...state,
                clientConfig: action.clientConfig,
                presentationConfig: action.presentationConfig,
            };
        case appActionTypes.SET_LANGUAGE:
            return {
                ...state,
                locale: action.nextLocale,
            };
        case loginActionTypes.GET_MEMBER_SUCCESS:
            return { ...state, memberLoggedIn: true, redirect: action.redirect };
        case rakutenServicesActionTypes.CANCEL_MEMBERSHIP_SUCCESS:
            return { ...state, memberLoggedIn: false };
        case PersonalInfoActionTypes.UPDATE_FAILURE:
            return { ...state, personalInfo: { error: action.error } };
        case appActionTypes.EXPIRED_SESSION_FOUND:
            return { ...state, sessionAlreadyExpired: true };
        case appActionTypes.CONFIGS_LOADED:
            return { ...state, isReady: true };
        // Didomi Related Changes
        case DidomiActionType.RAT_APPCONFIG:
            return { ...state, appConfig: action.appConfig };
        default:
            return state;
    }
}

export function memberReducer(state = {}, action) {
    switch (action.type) {
        case loginActionTypes.GET_MEMBER_SUCCESS:
            return action.user;
        case PersonalInfoActionTypes.UPDATE_SUCCESS:
            return { ...state, ...action.memberInfo };
        case UpdateEmailActionType.UPDATE_EMAIL_SUCCESS:
            return { ...state, email: action.payload.email };
        case UpdateUsernameActionType.UPDATE_USERNAME_SUCCESS:
            return { ...state, username: action.payload.username };
        case rakutenServicesActionTypes.CANCEL_MEMBERSHIP_SUCCESS:
            return {};
        default:
            return state;
    }
}
